import { useAppLoaderModule } from '@/store/global/appComponents/appLoader';
import { OpenAppLoader, CloseAppLoader } from '@/store/global/appComponents/appLoader/actions';

function open(delay: number = 400) {
    const store = useAppLoaderModule();
    store.dispatch(new OpenAppLoader(delay));
}

function close() {
    const store = useAppLoaderModule();
    store.dispatch(new CloseAppLoader());
}

export const appLoader = {
    open,
    close,
};
